import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Up: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWall2Up"><Path d="M7.25 9.25L12 4.5L16.75 9.25" stroke="currentColor" strokeLinecap="square"/><Path d="M12 20.5V5.25" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 3.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWall2Up;
